// SET CHATBOX FUNCTION PER PRODUCT
switch (window.TCMS.product) {
    case 'flug':
        import('./tcms_chatbox_flug.js').catch((err) => console.error(err));
        break;
    case 'hotel':
    case 'hotel_at':
        import('./tcms_chatbox_hotel.js').catch((err) => console.error(err));
        break;
    case 'mietwagen_at':
    case 'mietwagen':
        window.c24mw ? (window.c24mw.isCts = true) : (window.c24mw = { isCts: true });
        import('./tcms_chatbox_mietwagen.js').catch((err) => console.error(err));
        break;
    case 'urlaub':
    case 'urlaub_at':
        import('./tcms_chatbox_urlaub.js').catch((err) => console.error(err));
        break;
}
